import {Backdrop, Box, CircularProgress, LinearProgress, Typography} from '@mui/material'
import { useEffect, useState, useContext } from 'react';
import { Context } from "../App";
import AppLayout from '../components/layout/AppLayout';
import FastBoldInfoSection from '../components/sections/FastBoldInfoSection';
import DBEventsSection from '../components/sections/DBEventsSection';
import EventSellGraphSection from '../components/sections/EventSellGraphSection';

function Dashboard() {
  const { setIsConnected } = useContext(Context)
  const [loading, setLoading] = useState(false);
  const user = JSON.parse(sessionStorage.getItem('user'))
  const [events, setEvents] = useState([]);
  
    useEffect(() => {
      setLoading(true);
      if (!user || user.role === 'user') {
        sessionStorage.clear();
        setIsConnected(false);
        return;
      }
      const query = user.role==='super admin' ? {} : {_id: {$in: user.events}};
  
      fetch(process.env.REACT_APP_API_URL.concat('/events'), {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'authorization': 'Bearer ' + sessionStorage.getItem('token')
        }, body: JSON.stringify(query)
      }).then(async response => {
        const token = response.headers.get('x-auth-token');
        if (response.status === 401) {
          sessionStorage.clear();
          setIsConnected(false);
        } else {
          if (token && token !== sessionStorage.getItem('token') && token !== '') {
            sessionStorage.setItem('token', response.headers.get('x-auth-token'));
          }
          if (response.status === 200) {
            const json = await response.json();
            setEvents(json);
          }
        }
      }).catch(error => {
        console.error("Error fetching events:", error);
      }).finally(() => {
        setLoading(false);
      });
    }, []);

  useEffect(()=> {
    if (!user || user.role === 'user') {
      sessionStorage.clear();
      setIsConnected(false);
    }
  }, [user])


  return (
    <AppLayout>

      <Box sx={{ padding: 2 }}>
        <Typography variant="h4" gutterBottom>Tableau de bord</Typography>
        {loading && <LinearProgress sx={{mb:2}}/>}
  
        <FastBoldInfoSection />
        <DBEventsSection {...{events}}/>
        <EventSellGraphSection {...{events}}/>
  
        {/* <Backdrop open={loading}></Backdrop> */}
      </Box>

      <Backdrop open={loading}><CircularProgress/></Backdrop>
    </AppLayout>
  );
}

export default Dashboard;
